<template>
  <div>
    <router-link to="/" exact active-class="">
      <div v-if="!$route.params.id">
        <img src="../assets/logo.png" />
        <h3>McCarthy Interiors</h3>
      </div>
      <h3 v-else>{{ albums[$route.params.id].name }}</h3>
    </router-link>
    <hr />
    <ul id="navlist">
      <li><router-link to="/" exact>HOME</router-link></li>
      <li><router-link to="/gallery">GALLERY</router-link></li>
      <li><router-link to="/contact">CONTACT</router-link></li>
      <li>
        <a href="https://www.linkedin.com/in/tracey-mccarthy-5215a120"
          >LINKEDIN</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
  import albums from "../assets/albums.json";
  export default {
    name: "TopNav",
    data() {
      return {
        albums
      };
    }
  };
</script>

<style scoped>
  h3 {
    font-family: "Slabo 27px", serif;
    letter-spacing: 2px;
    font-size: 200%;
  }

  #navlist {
    padding-left: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 75%;
  }

  #navlist li {
    display: inline;
    list-style-type: none;
    padding-right: 20px;
    letter-spacing: 1px;
  }

  a:link,
  a:visited,
  a:hover {
    text-decoration: none;
    color: rgb(52, 52, 52);
  }

  hr {
    width: 60%;
    max-width: 960px;
    color: rgb(233, 233, 233);
  }

  .router-link-active {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue